import ManageDashboard from './ManageDashboard';

export default ManageDashboard;
